import ApiService from "@/common/api.service";
import {
  FETCH_CHART_ISSUES_STATUS,
  FETCH_CHART_VEHICLES_DISTANCE,
  FETCH_DASHBOARD_STATISTICS
} from "./actions.type";
import {
  FETCH_DASHBOARD_CHART_ISSUES_STATUS_START,
  FETCH_DASHBOARD_CHART_VEHICLES_DISTANCE_START,
  FETCH_DASHBOARD_START,
  SET_CHART_ISSUES_STATUS,
  SET_CHART_VEHICLES_DISTANCE,
  SET_DASHBOARD_STATISTICS
} from "./mutations.type";

const state = {
  dashboardStatistics: {},
  dashboardChartVehicleDistance: {},
  dashboardChartIssuesStatus: {},
  dashboardIsLoading: false,
  dashboardChartVehicleDistanceIsLoading: false,
  dashboardChartIssuesStatusIsLoading: false
};

const getters = {
  dashboardStatistics: state => state.dashboardStatistics,
  dashboardChartVehicleDistance: state => state.dashboardChartVehicleDistance,
  dashboardChartIssuesStatus: state => state.dashboardChartIssuesStatus,
  dashboardIsLoading: state => state.dashboardIsLoading,
  dashboardChartVehicleDistanceIsLoading: state =>
    state.dashboardChartVehicleDistanceIsLoading,
  dashboardChartIssuesStatusIsLoading: state =>
    state.dashboardChartIssuesStatusIsLoading
};

const actions = {
  [FETCH_DASHBOARD_STATISTICS](context) {
    context.commit(FETCH_DASHBOARD_START);
    return ApiService.get("dashboard/statistics").then(({ data }) => {
      context.commit(SET_DASHBOARD_STATISTICS, data);
    });
  },
  [FETCH_CHART_VEHICLES_DISTANCE](context) {
    context.commit(FETCH_DASHBOARD_CHART_VEHICLES_DISTANCE_START);
    return ApiService.get("dashboard/chart/vehicle/distance").then(
      ({ data }) => {
        context.commit(SET_CHART_VEHICLES_DISTANCE, data);
      }
    );
  },
  [FETCH_CHART_ISSUES_STATUS](context) {
    context.commit(FETCH_DASHBOARD_CHART_ISSUES_STATUS_START);
    return ApiService.get("dashboard/chart/issue/status-count").then(
      ({ data }) => {
        context.commit(SET_CHART_ISSUES_STATUS, data);
      }
    );
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_DASHBOARD_START](state) {
    state.dashboardIsLoading = true;
  },
  [FETCH_DASHBOARD_CHART_VEHICLES_DISTANCE_START](state) {
    state.dashboardChartVehicleDistanceIsLoading = true;
  },
  [FETCH_DASHBOARD_CHART_ISSUES_STATUS_START](state) {
    state.dashboardChartIssuesStatusIsLoading = true;
  },
  [SET_DASHBOARD_STATISTICS](state, data) {
    state.dashboardStatistics = data;
    state.dashboardIsLoading = false;
  },
  [SET_CHART_VEHICLES_DISTANCE](state, data) {
    state.dashboardChartVehicleDistance = data;
    state.dashboardChartVehicleDistanceIsLoading = false;
  },
  [SET_CHART_ISSUES_STATUS](state, data) {
    state.dashboardChartIssuesStatus = data;
    state.dashboardChartIssuesStatusIsLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
